<div class="sidebar-wrapper">
  <div class="side-bar-header">
    <div class="logo">
      <img src="./assets/logos/logo_white.svg" />
    </div>
    <div class="user-icon">
      <ion-icon
        title="Refresh"
        (click)="refresh()"
        color="light"
        name="refresh-outline"></ion-icon>
      &nbsp;
      <ion-icon
        name="person-circle"
        color="light"
        (click)="dropdown($event)"></ion-icon>
    </div>
  </div>
  <div class="logged-user-info">
    <div
      class="user-company ion-margin-top"
      *ngIf="userService.user$ | async as currentUser">
      {{ currentUser.companyName }}
    </div>
    <div class="side-logo">
      <img src="./assets/logos/company_avatar.jpg" />
    </div>
    <ng-container *ngIf="userService.user$ | async as currentUser">
      <div class="user-name">{{ currentUser.userName }}</div>
      <div class="user-email">{{ currentUser.userEmail }}</div>
    </ng-container>
  </div>
  <ul class="nav-item-list">
    <li
      [routerLink]="ROUTES.DASHBOARD_PAGE"
      routerLinkActive="active"
      *ngxPermissionsOnly="dashboardPagePermissions"
      (click)="close()">
      <span class="menu-icon">
        <ion-icon name="apps-outline"></ion-icon>
      </span>
      <span class="menu-text"> Dashboard</span>
    </li>
    <li
      [routerLink]="ROUTES.CUSTOMER_ORDERS_MAIN_PAGE"
      routerLinkActive="active"
      *ngxPermissionsOnly="customerOrderPagePermissions"
      (click)="close()">
      <span class="menu-icon">
        <ion-icon name="cart-outline"></ion-icon>
      </span>
      <span class="menu-text"> Customer Orders </span>
    </li>
    <li
      *ngxPermissionsOnly="operationsPagePermissions"
      [routerLink]="ROUTES.OPERATIONS_PAGE"
      routerLinkActive="active"
      (click)="close()">
      <span class="menu-icon">
        <ion-icon name="hammer-outline"></ion-icon>
      </span>
      <span class="menu-text"> Operations </span>
    </li>
    <li
      *ngIf="canShowDimensionsLink"
      [routerLink]="ROUTES.DIMENSIONS_LIST_PAGE"
      routerLinkActive="active"
      (click)="close()">
      <span class="menu-icon">
        <ion-icon name="book-outline"></ion-icon>
      </span>
      <span class="menu-text"> Dimensions </span>
    </li>
    <li
      *ngxPermissionsOnly="managePagePermissions"
      [routerLink]="ROUTES.MANAGE_PAGE"
      routerLinkActive="active"
      (click)="close()">
      <span class="menu-icon">
        <ion-icon name="clipboard-outline"></ion-icon>
      </span>
      <span class="menu-text"> Manage </span>
    </li>
    <li
      *ngxPermissionsOnly="[
        'view_quick_search_search_customers',
        'view_quick_search_search_products'
      ]"
      [routerLink]="ROUTES.QUICK_SEARCH_PAGE"
      routerLinkActive="active"
      (click)="close()">
      <span class="menu-icon">
        <ion-icon name="search-outline"></ion-icon>
      </span>
      <span class="menu-text"> Quick Search </span>
    </li>
    <li
      *ngIf="canShowReportLink"
      [routerLink]="ROUTES.REPORTS_PAGE"
      routerLinkActive="active"
      (click)="close()">
      <span class="menu-icon">
        <ion-icon name="document-outline"></ion-icon>
      </span>
      <span class="menu-text"> Reports </span>
    </li>
    <li
      *ngIf="canShowAdminLink"
      [routerLink]="ROUTES.ADMINISTRATION"
      routerLinkActive="active"
      (click)="close()">
      <span class="menu-icon">
        <ion-icon name="settings-outline"></ion-icon>
      </span>
      <span class="menu-text"> Administration </span>
    </li>
    <li
      [routerLink]="ROUTES.HELP_PAGE"
      routerLinkActive="active"
      (click)="close()">
      <span class="menu-icon">
        <ion-icon name="help-circle-outline"></ion-icon>
      </span>
      <span class="menu-text"> Help </span>
    </li>
  </ul>
</div>
